import { useQuery } from '@tanstack/react-query';
import { ReactNode, createContext, useEffect, useState } from 'react';
import { fetchUserInfo } from '../api/user-client/user-client';
import type { UserInfo } from '../api/user-client/user-client.type';
import { getRequestToken, isValidAccessToken, logout } from '../helpers/storage/storage';
import type { UserContextType } from './user.type';

export const UserContext = createContext({} as UserContextType);

export function UserProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<UserInfo | null>(null);

  const userQuery = useQuery({
    queryKey: ['user'] as const,
    queryFn: async () => {
      if (!getRequestToken()) {
        throw new Error('No request token available');
      }
      return fetchUserInfo();
    },
    enabled: !user && isValidAccessToken(),
  });

  useEffect(() => {
    if (userQuery.data) {
      setUser(userQuery.data);
    }
  }, [userQuery.data]);

  useEffect(() => {
    if (userQuery.isError) {
      logout();
    }
  }, [userQuery.isError]);

  return <UserContext.Provider value={{ user, setUser, query: userQuery }}>{children}</UserContext.Provider>;
}
